"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mitt_1 = tslib_1.__importDefault(require("mitt"));
exports.FLAG_PREFIX = 'flagKey.';
exports.ALL_FLAGS = 'allFlags';
var Subscriptions = /** @class */ (function () {
    function Subscriptions() {
        this.emitter = mitt_1.default();
    }
    Subscriptions.prototype.on = function (flagKey, defaultValue, callback, getFlagValue, options) {
        var _this = this;
        var wrapCallback = function () { return callback(getFlagValue(flagKey, defaultValue, options)); };
        this.emitter.on(exports.FLAG_PREFIX + flagKey, wrapCallback);
        return function () { return _this.emitter.off(exports.FLAG_PREFIX + flagKey, wrapCallback); };
    };
    Subscriptions.prototype.onAnyFlagUpdated = function (callback) {
        var _this = this;
        this.emitter.on(exports.ALL_FLAGS, callback);
        return function () { return _this.emitter.off(exports.ALL_FLAGS, callback); };
    };
    Subscriptions.prototype.anyFlagUpdated = function () {
        this.emitter.emit(exports.ALL_FLAGS);
    };
    Subscriptions.prototype.flagValueUpdated = function (flagKey) {
        this.emitter.emit(exports.FLAG_PREFIX + flagKey);
    };
    Subscriptions.prototype.stop = function () {
        // There is no way to clear the emitter so instead we're creating a new one
        this.emitter = mitt_1.default();
    };
    return Subscriptions;
}());
exports.default = Subscriptions;
